import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const DownArrowIcon = ({tintColor = '#001533', ...props}) => {
  return (
    <Svg
      width={10}
      height={6}
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.53.345a.75.75 0 010 1.06l-4 4a.75.75 0 01-1.06 0l-4-4A.75.75 0 011.53.346L5 3.815 8.47.345a.75.75 0 011.06 0z"
        fill={tintColor}
      />
    </Svg>
  );
};

export default DownArrowIcon;
